/**
 * Check if an object is an error
 */
export const isError = (obj: any): obj is Error => {
	return obj instanceof Error || Object.prototype.toString.call(obj) === '[object Error]';
};
